// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.send-feedback-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: calc(100vh - 64px);
  padding: 2rem 1rem;
  background-color: #f5f5f5;
}
.send-feedback-container .feedback-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  max-width: 700px;
  width: 100%;
}
.send-feedback-container .feedback-card .feedback-header {
  margin-bottom: 2rem;
  text-align: center;
}
.send-feedback-container .feedback-card .feedback-header h1 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin: 0 0 0.5rem 0;
  font-size: 2rem;
  font-weight: 500;
  color: #212121;
}
.send-feedback-container .feedback-card .feedback-header h1 mat-icon {
  font-size: 2rem;
  width: 2rem;
  height: 2rem;
  color: #1976d2;
}
.send-feedback-container .feedback-card .feedback-header .subtitle {
  color: #666;
  font-size: 0.95rem;
  margin: 0;
}
.send-feedback-container .feedback-card .form-section {
  margin-bottom: 1.5rem;
}
.send-feedback-container .feedback-card .form-section label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #424242;
  font-size: 0.95rem;
}
.send-feedback-container .feedback-card .form-section label mat-icon {
  font-size: 1.2rem;
  width: 1.2rem;
  height: 1.2rem;
  color: #666;
}
.send-feedback-container .feedback-card .form-section label.required::after {
  content: " *";
  color: #d32f2f;
}
.send-feedback-container .feedback-card .form-section .full-width {
  width: 100%;
}
.send-feedback-container .feedback-card .form-section .rating-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
}
.send-feedback-container .feedback-card .form-section .rating-container .star-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;
}
.send-feedback-container .feedback-card .form-section .rating-container .star-button:hover {
  transform: scale(1.1);
}
.send-feedback-container .feedback-card .form-section .rating-container .star-button mat-icon {
  font-size: 2rem;
  width: 2rem;
  height: 2rem;
  color: #ffc107;
}
.send-feedback-container .feedback-card .form-section .rating-container .star-button mat-icon.active {
  color: #ffc107;
}
.send-feedback-container .feedback-card .form-section .rating-container .star-button:focus {
  outline: 2px solid #1976d2;
  outline-offset: 2px;
  border-radius: 4px;
}
.send-feedback-container .feedback-card .form-section .rating-container .rating-text {
  margin-left: 0.5rem;
  color: #666;
  font-size: 0.9rem;
}
.send-feedback-container .feedback-card .form-section .image-hint {
  font-size: 0.85rem;
  color: #666;
  margin: 0.5rem 0 1rem 0;
}
.send-feedback-container .feedback-card .form-section .image-upload-container {
  margin-top: 0.5rem;
}
.send-feedback-container .feedback-card .form-section .image-upload-container .upload-button-wrapper {
  position: relative;
  display: inline-block;
}
.send-feedback-container .feedback-card .form-section .image-upload-container .upload-button-wrapper .file-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  overflow: hidden;
}
.send-feedback-container .feedback-card .form-section .image-upload-container .upload-progress {
  margin-top: 1rem;
}
.send-feedback-container .feedback-card .form-section .image-upload-container .upload-progress mat-progress-bar {
  height: 8px;
  border-radius: 4px;
}
.send-feedback-container .feedback-card .form-section .image-upload-container .upload-progress .progress-text {
  display: block;
  margin-top: 0.5rem;
  font-size: 0.85rem;
  color: #666;
  text-align: center;
}
.send-feedback-container .feedback-card .form-section .image-upload-container .uploaded-images {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 1rem;
}
.send-feedback-container .feedback-card .form-section .image-upload-container .uploaded-images .image-preview {
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid #e0e0e0;
  background: #f5f5f5;
}
.send-feedback-container .feedback-card .form-section .image-upload-container .uploaded-images .image-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.send-feedback-container .feedback-card .form-section .image-upload-container .uploaded-images .image-preview .remove-image-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
}
.send-feedback-container .feedback-card .form-section .image-upload-container .uploaded-images .image-preview .remove-image-btn:hover {
  background: rgba(0, 0, 0, 0.8);
}
.send-feedback-container .feedback-card .form-section .image-upload-container .uploaded-images .image-preview .remove-image-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.send-feedback-container .feedback-card .form-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e0e0e0;
}
.send-feedback-container .feedback-card .form-actions .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 18px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  text-transform: none;
  letter-spacing: 0;
  min-width: 120px;
}
.send-feedback-container .feedback-card .form-actions .btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.send-feedback-container .feedback-card .form-actions .btn .inline-spinner {
  display: inline-block;
  margin-right: 0.5rem;
}
.send-feedback-container .feedback-card .form-actions .btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.send-feedback-container .feedback-card .form-actions .btn-primary {
  background: #065fd4;
  color: #fff;
}
.send-feedback-container .feedback-card .form-actions .btn-primary:hover:not(:disabled) {
  background: #0d47a1;
}
.send-feedback-container .feedback-card .form-actions .btn-primary:disabled {
  background: #e0e0e0;
  color: #909090;
}
.send-feedback-container .feedback-card .form-actions .btn-secondary {
  background: transparent;
  color: #065fd4;
  border: 1px solid #065fd4;
}
.send-feedback-container .feedback-card .form-actions .btn-secondary:hover:not(:disabled) {
  background: #f0f7ff;
}
.send-feedback-container .feedback-card .form-actions .btn-secondary:disabled {
  border-color: #e0e0e0;
  color: #909090;
}

@media (max-width: 768px) {
  .send-feedback-container {
    padding: 1rem 0.5rem;
  }
  .send-feedback-container .feedback-card {
    padding: 1.5rem;
  }
  .send-feedback-container .feedback-card .feedback-header h1 {
    font-size: 1.5rem;
  }
  .send-feedback-container .feedback-card .form-actions {
    flex-direction: column-reverse;
  }
  .send-feedback-container .feedback-card .form-actions .btn {
    width: 100%;
  }
}
.upload-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 18px;
  background: #065fd4;
  color: #fff;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;
  text-transform: none;
  letter-spacing: 0;
}
.upload-btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.upload-btn:hover:not(:disabled) {
  background: #0d47a1;
}
.upload-btn:disabled {
  background: #e0e0e0;
  color: #909090;
  cursor: not-allowed;
}

:host-context(body.theme-dark) .send-feedback-container {
  background-color: #1a1a2e;
}
:host-context(body.theme-dark) .send-feedback-container .feedback-card {
  background: #1e2a3a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
}
:host-context(body.theme-dark) .send-feedback-container .feedback-card .feedback-header h1 {
  color: #e8eaed;
}
:host-context(body.theme-dark) .send-feedback-container .feedback-card .feedback-header h1 mat-icon {
  color: #5ea1d8;
}
:host-context(body.theme-dark) .send-feedback-container .feedback-card .feedback-header .subtitle {
  color: #9aa0a6;
}
:host-context(body.theme-dark) .send-feedback-container .feedback-card .form-section label {
  color: #bdc1c6;
}
:host-context(body.theme-dark) .send-feedback-container .feedback-card .form-section label mat-icon {
  color: #9aa0a6;
}
:host-context(body.theme-dark) .send-feedback-container .feedback-card .form-section .rating-container {
  /* Keep golden star color in dark mode */
}
:host-context(body.theme-dark) .send-feedback-container .feedback-card .form-section .rating-container .rating-text {
  color: #9aa0a6;
}
:host-context(body.theme-dark) .send-feedback-container .feedback-card .form-section .rating-container .star-button mat-icon,
:host-context(body.theme-dark) .send-feedback-container .feedback-card .form-section .rating-container .star-button.active mat-icon,
:host-context(body.theme-dark) .send-feedback-container .feedback-card .form-section .rating-container .star-button mat-icon.active {
  color: #ffc107 !important;
}
:host-context(body.theme-dark) .send-feedback-container .feedback-card .form-section .image-hint {
  color: #9aa0a6;
}
:host-context(body.theme-dark) .send-feedback-container .feedback-card .form-section .image-upload-container .upload-progress .progress-text {
  color: #9aa0a6;
}
:host-context(body.theme-dark) .send-feedback-container .feedback-card .form-section .image-upload-container .uploaded-images .image-preview {
  border-color: #3c4043;
  background: #2d3748;
}
:host-context(body.theme-dark) .send-feedback-container .feedback-card .form-actions {
  border-top-color: #3c4043;
}
:host-context(body.theme-dark) .send-feedback-container .feedback-card .form-actions .btn-primary {
  background: #1a73e8;
}
:host-context(body.theme-dark) .send-feedback-container .feedback-card .form-actions .btn-primary:hover:not(:disabled) {
  background: #1557b0;
}
:host-context(body.theme-dark) .send-feedback-container .feedback-card .form-actions .btn-primary:disabled {
  background: #3c4043;
  color: #5f6368;
}
:host-context(body.theme-dark) .send-feedback-container .feedback-card .form-actions .btn-secondary {
  color: #8ab4f8;
  border-color: #8ab4f8;
}
:host-context(body.theme-dark) .send-feedback-container .feedback-card .form-actions .btn-secondary:hover:not(:disabled) {
  background: rgba(138, 180, 248, 0.08);
}
:host-context(body.theme-dark) .send-feedback-container .feedback-card .form-actions .btn-secondary:disabled {
  border-color: #3c4043;
  color: #5f6368;
}
:host-context(body.theme-dark) .upload-btn {
  background: #1a73e8;
}
:host-context(body.theme-dark) .upload-btn:hover:not(:disabled) {
  background: #1557b0;
}
:host-context(body.theme-dark) .upload-btn:disabled {
  background: #3c4043;
  color: #5f6368;
}

::ng-deep .mat-form-field-appearance-outline .mat-form-field-outline {
  color: #bdbdbd;
}
::ng-deep .mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick {
  color: #1976d2;
}
::ng-deep .mat-form-field-invalid .mat-form-field-outline-thick {
  color: #d32f2f !important;
}

body.theme-dark ::ng-deep app-send-feedback .mat-form-field-appearance-outline .mat-form-field-outline {
  color: #5f6368;
}
body.theme-dark ::ng-deep app-send-feedback .mat-form-field-appearance-outline .mat-form-field-outline-thick {
  color: #8ab4f8;
}
body.theme-dark ::ng-deep app-send-feedback .mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick {
  color: #8ab4f8;
}
body.theme-dark ::ng-deep app-send-feedback .mat-form-field-appearance-outline .mat-form-field-label {
  color: #9aa0a6;
}
body.theme-dark ::ng-deep app-send-feedback .mat-form-field-appearance-outline .mat-input-element,
body.theme-dark ::ng-deep app-send-feedback .mat-form-field-appearance-outline .mat-select-value,
body.theme-dark ::ng-deep app-send-feedback .mat-form-field-appearance-outline textarea {
  color: #e8eaed;
  caret-color: #8ab4f8;
}
body.theme-dark ::ng-deep app-send-feedback .mat-form-field-appearance-outline .mat-select-arrow {
  color: #9aa0a6;
}
body.theme-dark ::ng-deep app-send-feedback .mat-form-field-appearance-outline .mat-hint {
  color: #9aa0a6;
}
body.theme-dark ::ng-deep app-send-feedback .mat-form-field-appearance-outline .mat-form-field-wrapper {
  background: #2d3748;
  border-radius: 4px;
}
body.theme-dark ::ng-deep app-send-feedback .mat-option {
  color: #e8eaed;
  background: #1e2a3a;
}
body.theme-dark ::ng-deep app-send-feedback .mat-option:hover, body.theme-dark ::ng-deep app-send-feedback .mat-option.mat-active {
  background: #2d3748;
}
body.theme-dark ::ng-deep app-send-feedback .mat-option.mat-selected:not(.mat-option-multiple) {
  background: #2d3748;
  color: #8ab4f8;
}
body.theme-dark ::ng-deep app-send-feedback .mat-select-panel {
  background: #1e2a3a;
}

.hp-field {
  position: absolute;
  left: -10000px;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/send-feedback/send-feedback.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,8BAAA;EACA,kBAAA;EACA,yBAAA;AACF;AACE;EACE,iBAAA;EACA,kBAAA;EACA,wCAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;AACJ;AACI;EACE,mBAAA;EACA,kBAAA;AACN;AACM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACR;AACQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AACV;AAGM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;AADR;AAKI;EACE,qBAAA;AAHN;AAKM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAHR;AAKQ;EACE,iBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;AAHV;AAMQ;EACE,aAAA;EACA,cAAA;AAJV;AAQM;EACE,WAAA;AANR;AASM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAPR;AASQ;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;AAPV;AASU;EACE,qBAAA;AAPZ;AAUU;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AARZ;AAUY;EACE,cAAA;AARd;AAYU;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;AAVZ;AAcQ;EACE,mBAAA;EACA,WAAA;EACA,iBAAA;AAZV;AAgBM;EACE,kBAAA;EACA,WAAA;EACA,uBAAA;AAdR;AAiBM;EACE,kBAAA;AAfR;AAiBQ;EACE,kBAAA;EACA,qBAAA;AAfV;AAiBU;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;AAfZ;AAmBQ;EACE,gBAAA;AAjBV;AAmBU;EACE,WAAA;EACA,kBAAA;AAjBZ;AAoBU;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AAlBZ;AAsBQ;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AApBV;AAsBU;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AApBZ;AAsBY;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AApBd;AAuBY;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,2BAAA;AArBd;AAuBc;EACE,8BAAA;AArBhB;AAwBc;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAtBhB;AA8BI;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;AA5BN;AA8BM;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;AA5BR;AA8BQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA5BV;AA+BQ;EACE,qBAAA;EACA,oBAAA;AA7BV;AAgCQ;EACE,mBAAA;EACA,YAAA;AA9BV;AAkCM;EACE,mBAAA;EACA,WAAA;AAhCR;AAkCQ;EACE,mBAAA;AAhCV;AAmCQ;EACE,mBAAA;EACA,cAAA;AAjCV;AAqCM;EACE,uBAAA;EACA,cAAA;EACA,yBAAA;AAnCR;AAqCQ;EACE,mBAAA;AAnCV;AAsCQ;EACE,qBAAA;EACA,cAAA;AApCV;;AA4CA;EACE;IACE,oBAAA;EAzCF;EA2CE;IACE,eAAA;EAzCJ;EA2CI;IACE,iBAAA;EAzCN;EA4CI;IACE,8BAAA;EA1CN;EA4CM;IACE,WAAA;EA1CR;AACF;AAiDA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;EACA,oBAAA;EACA,iBAAA;AA/CF;AAiDE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA/CJ;AAkDE;EACE,mBAAA;AAhDJ;AAmDE;EACE,mBAAA;EACA,cAAA;EACA,mBAAA;AAjDJ;;AAuDE;EACE,yBAAA;AApDJ;AAsDI;EACE,mBAAA;EACA,wCAAA;AApDN;AAuDQ;EACE,cAAA;AArDV;AAuDU;EACE,cAAA;AArDZ;AAyDQ;EACE,cAAA;AAvDV;AA4DQ;EACE,cAAA;AA1DV;AA4DU;EACE,cAAA;AA1DZ;AA8DQ;EAKE,wCAAA;AAhEV;AA4DU;EACE,cAAA;AA1DZ;AA8DU;;;EAGE,yBAAA;AA5DZ;AAgEQ;EACE,cAAA;AA9DV;AAmEY;EACE,cAAA;AAjEd;AAsEY;EACE,qBAAA;EACA,mBAAA;AApEd;AA0EM;EACE,yBAAA;AAxER;AA0EQ;EACE,mBAAA;AAxEV;AA0EU;EACE,mBAAA;AAxEZ;AA2EU;EACE,mBAAA;EACA,cAAA;AAzEZ;AA6EQ;EACE,cAAA;EACA,qBAAA;AA3EV;AA6EU;EACE,qCAAA;AA3EZ;AA8EU;EACE,qBAAA;EACA,cAAA;AA5EZ;AAmFE;EACE,mBAAA;AAjFJ;AAmFI;EACE,mBAAA;AAjFN;AAoFI;EACE,mBAAA;EACA,cAAA;AAlFN;;AA0FI;EACE,cAAA;AAvFN;AA0FI;EACE,cAAA;AAxFN;AA6FI;EACE,yBAAA;AA3FN;;AAmGI;EACE,cAAA;AAhGN;AAmGI;EACE,cAAA;AAjGN;AAoGI;EACE,cAAA;AAlGN;AAqGI;EACE,cAAA;AAnGN;AAsGI;;;EAGE,cAAA;EACA,oBAAA;AApGN;AAuGI;EACE,cAAA;AArGN;AAwGI;EACE,cAAA;AAtGN;AAyGI;EACE,mBAAA;EACA,kBAAA;AAvGN;AA2GE;EACE,cAAA;EACA,mBAAA;AAzGJ;AA2GI;EAEE,mBAAA;AA1GN;AA6GI;EACE,mBAAA;EACA,cAAA;AA3GN;AA+GE;EACE,mBAAA;AA7GJ;;AAiHA;EACE,kBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,oBAAA;AA9GF","sourcesContent":[".send-feedback-container {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  min-height: calc(100vh - 64px);\n  padding: 2rem 1rem;\n  background-color: #f5f5f5;\n\n  .feedback-card {\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    padding: 2rem;\n    max-width: 700px;\n    width: 100%;\n\n    .feedback-header {\n      margin-bottom: 2rem;\n      text-align: center;\n\n      h1 {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 0.5rem;\n        margin: 0 0 0.5rem 0;\n        font-size: 2rem;\n        font-weight: 500;\n        color: #212121;\n\n        mat-icon {\n          font-size: 2rem;\n          width: 2rem;\n          height: 2rem;\n          color: #1976d2;\n        }\n      }\n\n      .subtitle {\n        color: #666;\n        font-size: 0.95rem;\n        margin: 0;\n      }\n    }\n\n    .form-section {\n      margin-bottom: 1.5rem;\n\n      label {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n        margin-bottom: 0.5rem;\n        font-weight: 500;\n        color: #424242;\n        font-size: 0.95rem;\n\n        mat-icon {\n          font-size: 1.2rem;\n          width: 1.2rem;\n          height: 1.2rem;\n          color: #666;\n        }\n\n        &.required::after {\n          content: \" *\";\n          color: #d32f2f;\n        }\n      }\n\n      .full-width {\n        width: 100%;\n      }\n\n      .rating-container {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n        margin-top: 0.5rem;\n\n        .star-button {\n          background: none;\n          border: none;\n          cursor: pointer;\n          padding: 0.25rem;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          transition: transform 0.2s;\n\n          &:hover {\n            transform: scale(1.1);\n          }\n\n          mat-icon {\n            font-size: 2rem;\n            width: 2rem;\n            height: 2rem;\n            color: #ffc107;\n\n            &.active {\n              color: #ffc107;\n            }\n          }\n\n          &:focus {\n            outline: 2px solid #1976d2;\n            outline-offset: 2px;\n            border-radius: 4px;\n          }\n        }\n\n        .rating-text {\n          margin-left: 0.5rem;\n          color: #666;\n          font-size: 0.9rem;\n        }\n      }\n\n      .image-hint {\n        font-size: 0.85rem;\n        color: #666;\n        margin: 0.5rem 0 1rem 0;\n      }\n\n      .image-upload-container {\n        margin-top: 0.5rem;\n\n        .upload-button-wrapper {\n          position: relative;\n          display: inline-block;\n\n          .file-input {\n            position: absolute;\n            opacity: 0;\n            width: 0;\n            height: 0;\n            overflow: hidden;\n          }\n        }\n\n        .upload-progress {\n          margin-top: 1rem;\n\n          mat-progress-bar {\n            height: 8px;\n            border-radius: 4px;\n          }\n\n          .progress-text {\n            display: block;\n            margin-top: 0.5rem;\n            font-size: 0.85rem;\n            color: #666;\n            text-align: center;\n          }\n        }\n\n        .uploaded-images {\n          display: flex;\n          flex-wrap: wrap;\n          gap: 1rem;\n          margin-top: 1rem;\n\n          .image-preview {\n            position: relative;\n            width: 120px;\n            height: 120px;\n            border-radius: 8px;\n            overflow: hidden;\n            border: 2px solid #e0e0e0;\n            background: #f5f5f5;\n\n            img {\n              width: 100%;\n              height: 100%;\n              object-fit: cover;\n            }\n\n            .remove-image-btn {\n              position: absolute;\n              top: 4px;\n              right: 4px;\n              background: rgba(0, 0, 0, 0.6);\n              color: white;\n              border: none;\n              border-radius: 50%;\n              width: 28px;\n              height: 28px;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              cursor: pointer;\n              transition: background 0.2s;\n\n              &:hover {\n                background: rgba(0, 0, 0, 0.8);\n              }\n\n              mat-icon {\n                font-size: 18px;\n                width: 18px;\n                height: 18px;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .form-actions {\n      display: flex;\n      justify-content: flex-end;\n      align-items: center;\n      gap: 1rem;\n      margin-top: 2rem;\n      padding-top: 1.5rem;\n      border-top: 1px solid #e0e0e0;\n\n      .btn {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        gap: 0.5rem;\n        padding: 10px 24px;\n        font-size: 14px;\n        font-weight: 500;\n        border-radius: 18px;\n        border: none;\n        cursor: pointer;\n        transition: all 0.2s;\n        text-transform: none;\n        letter-spacing: 0;\n        min-width: 120px;\n\n        mat-icon {\n          font-size: 20px;\n          width: 20px;\n          height: 20px;\n        }\n\n        .inline-spinner {\n          display: inline-block;\n          margin-right: 0.5rem;\n        }\n\n        &:disabled {\n          cursor: not-allowed;\n          opacity: 0.6;\n        }\n      }\n\n      .btn-primary {\n        background: #065fd4;\n        color: #fff;\n\n        &:hover:not(:disabled) {\n          background: #0d47a1;\n        }\n\n        &:disabled {\n          background: #e0e0e0;\n          color: #909090;\n        }\n      }\n\n      .btn-secondary {\n        background: transparent;\n        color: #065fd4;\n        border: 1px solid #065fd4;\n\n        &:hover:not(:disabled) {\n          background: #f0f7ff;\n        }\n\n        &:disabled {\n          border-color: #e0e0e0;\n          color: #909090;\n        }\n      }\n    }\n  }\n}\n\n// Responsive design\n@media (max-width: 768px) {\n  .send-feedback-container {\n    padding: 1rem 0.5rem;\n\n    .feedback-card {\n      padding: 1.5rem;\n\n      .feedback-header h1 {\n        font-size: 1.5rem;\n      }\n\n      .form-actions {\n        flex-direction: column-reverse;\n\n        .btn {\n          width: 100%;\n        }\n      }\n    }\n  }\n}\n\n// Upload button styles matching Flowchest\n.upload-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 10px 24px;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 18px;\n  background: #065fd4;\n  color: #fff;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  text-transform: none;\n  letter-spacing: 0;\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n\n  &:hover:not(:disabled) {\n    background: #0d47a1;\n  }\n\n  &:disabled {\n    background: #e0e0e0;\n    color: #909090;\n    cursor: not-allowed;\n  }\n}\n\n// Dark mode\n:host-context(body.theme-dark) {\n  .send-feedback-container {\n    background-color: #1a1a2e;\n\n    .feedback-card {\n      background: #1e2a3a;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);\n\n      .feedback-header {\n        h1 {\n          color: #e8eaed;\n\n          mat-icon {\n            color: #5ea1d8;\n          }\n        }\n\n        .subtitle {\n          color: #9aa0a6;\n        }\n      }\n\n      .form-section {\n        label {\n          color: #bdc1c6;\n\n          mat-icon {\n            color: #9aa0a6;\n          }\n        }\n\n        .rating-container {\n          .rating-text {\n            color: #9aa0a6;\n          }\n\n          /* Keep golden star color in dark mode */\n          .star-button mat-icon,\n          .star-button.active mat-icon,\n          .star-button mat-icon.active {\n            color: #ffc107 !important;\n          }\n        }\n\n        .image-hint {\n          color: #9aa0a6;\n        }\n\n        .image-upload-container {\n          .upload-progress {\n            .progress-text {\n              color: #9aa0a6;\n            }\n          }\n\n          .uploaded-images {\n            .image-preview {\n              border-color: #3c4043;\n              background: #2d3748;\n            }\n          }\n        }\n      }\n\n      .form-actions {\n        border-top-color: #3c4043;\n\n        .btn-primary {\n          background: #1a73e8;\n\n          &:hover:not(:disabled) {\n            background: #1557b0;\n          }\n\n          &:disabled {\n            background: #3c4043;\n            color: #5f6368;\n          }\n        }\n\n        .btn-secondary {\n          color: #8ab4f8;\n          border-color: #8ab4f8;\n\n          &:hover:not(:disabled) {\n            background: rgba(138, 180, 248, 0.08);\n          }\n\n          &:disabled {\n            border-color: #3c4043;\n            color: #5f6368;\n          }\n        }\n      }\n    }\n  }\n\n  .upload-btn {\n    background: #1a73e8;\n\n    &:hover:not(:disabled) {\n      background: #1557b0;\n    }\n\n    &:disabled {\n      background: #3c4043;\n      color: #5f6368;\n    }\n  }\n}\n\n// Material form field customizations\n::ng-deep {\n  .mat-form-field-appearance-outline {\n    .mat-form-field-outline {\n      color: #bdbdbd;\n    }\n\n    &.mat-focused .mat-form-field-outline-thick {\n      color: #1976d2;\n    }\n  }\n\n  .mat-form-field-invalid {\n    .mat-form-field-outline-thick {\n      color: #d32f2f !important;\n    }\n  }\n}\n\n// Dark mode Material form field overrides\nbody.theme-dark ::ng-deep app-send-feedback {\n  .mat-form-field-appearance-outline {\n    .mat-form-field-outline {\n      color: #5f6368;\n    }\n\n    .mat-form-field-outline-thick {\n      color: #8ab4f8;\n    }\n\n    &.mat-focused .mat-form-field-outline-thick {\n      color: #8ab4f8;\n    }\n\n    .mat-form-field-label {\n      color: #9aa0a6;\n    }\n\n    .mat-input-element,\n    .mat-select-value,\n    textarea {\n      color: #e8eaed;\n      caret-color: #8ab4f8;\n    }\n\n    .mat-select-arrow {\n      color: #9aa0a6;\n    }\n\n    .mat-hint {\n      color: #9aa0a6;\n    }\n\n    .mat-form-field-wrapper {\n      background: #2d3748;\n      border-radius: 4px;\n    }\n  }\n\n  .mat-option {\n    color: #e8eaed;\n    background: #1e2a3a;\n\n    &:hover,\n    &.mat-active {\n      background: #2d3748;\n    }\n\n    &.mat-selected:not(.mat-option-multiple) {\n      background: #2d3748;\n      color: #8ab4f8;\n    }\n  }\n\n  .mat-select-panel {\n    background: #1e2a3a;\n  }\n}\n\n.hp-field {\n  position: absolute;\n  left: -10000px;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  opacity: 0;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
